const c = {
  name: "Hands01000",
  dimensions: { width: 26, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 38" style="enable-background:new 0 0 26 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,8.5V4c0-2.2-1.8-4-4-4C1.8,0,0,1.8,0,4v21c0,7.2,5.8,13,13,13s13-5.8,13-13v-9c0-2.2-1.8-4-4-4
			c-0.8,0-1.6,0.2-2.2,0.7c-0.5-1.6-2-2.7-3.8-2.7c-0.8,0-1.6,0.2-2.2,0.7C13.2,9.1,11.7,8,10,8C9.3,8,8.6,8.2,8,8.5z M2,4
			c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v13H4c-0.7,0-1.4,0.2-2,0.5V4z M8,17v-5c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v5.5
			c-0.6-0.3-1.3-0.5-2-0.5H8z M14,14c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V14z M12,21
			c0,1.1-0.9,2-2,2H6v2h4c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4c1.7,0,3.2-1.1,3.8-2.7c0.6,0.4,1.4,0.7,2.2,0.7
			c0.7,0,1.4-0.2,2-0.5V25c0,6.1-4.9,11-11,11C6.9,36,2,31.1,2,25v-4c0-1.1,0.9-2,2-2h6C11.1,19,12,19.9,12,21z M24,19
			c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v-3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2V19z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands01000
};
